export default __webpack_public_path__ + "static/media/client14.7bc5a7db.png";